import React from 'react';
function ArrowRight({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 19l7-7-7-7" />
    </svg>
  );
}

export default ArrowRight;
